import React from 'react';
import { useParams } from 'react-router';
import { useLocalContentProduct } from '../../../../api/local-content/collection/product/useLocalContentProduct';
import { useCountries } from '../../api/useCountries';
import { LCProductDetailReadView } from './LCProductDetailReadView';
import { useDeleteProductCover } from '../../../../api/local-content/collection/product/useDeleteProductCover';
import { useWithdrawLocalContentProduct } from '../../../../api/local-content/collection/product/useWithdrawLocalContentProduct';
import { useSetProductLiveOnLibx } from '../../../../api/local-content/collection/product/useSetProductLiveOnLibx';
import { usePublishLocalContentProduct } from '../../../../api/local-content/collection/product/usePublishLocalContentProduct';
import { useRepublishLocalContentProduct } from '../../../../api/local-content/collection/product/useRepublishLocalContentProduct';
import { useDeactivateLocalContentProduct } from '../../../../api/local-content/collection/product/useDeactivateLocalContentProduct';
import { useSaveLibxSettings } from '../../../../api/local-content/collection/product/useSaveLibxSettings';
import { useDeleteLocalContentProduct } from '../../../../api/local-content/collection/product/useDeleteLocalContentProduct';
import { useReactivateLocalContentProduct } from '../../../../api/local-content/collection/product/useReactivateLocalContentProduct';
import {
    UploadProgressCallback,
    useUploadLocalContentAsset,
    useUploadLocalContentCover
} from '../../../../api/local-content/collection/product/useUploadLocalContentAsset';
import { useAuthentication } from '../../../../app-store/authentication/useAuthentication';
import { useNavigate } from 'react-router-dom';

export const LCProductDetailReadPage = () => {
    const { id = '' } = useParams<'id'>();
    const navigate = useNavigate();
    const authentication = useAuthentication();
    const { data: product, isLoading: isProductLoading } = useLocalContentProduct(id);
    const { data: countries, isLoading: isCountriesLoading } = useCountries({});
    const { mutate: deleteProductCoverMutation } = useDeleteProductCover(id);
    const { mutate: uploadProductCoverMutation } = useUploadLocalContentCover(id);
    const { mutate: uploadProductAssetMutation } = useUploadLocalContentAsset(id);
    const { mutate: withdrawProductMutation } = useWithdrawLocalContentProduct(id);
    const { mutate: setLiveProductMutation } = useSetProductLiveOnLibx(id);
    const { mutate: publishProductMutation } = usePublishLocalContentProduct(id);
    const { mutate: republishProductMutation } = useRepublishLocalContentProduct(id);
    const { mutate: deactivateProductMutation } = useDeactivateLocalContentProduct(id);
    const { mutate: saveLibxSettingsMutation } = useSaveLibxSettings(id);
    const { mutate: deleteLocalContentProductMutation } = useDeleteLocalContentProduct(id);
    const { mutate: reactivateLocalContentProductMutation } = useReactivateLocalContentProduct(id);
    const loading = isProductLoading || isCountriesLoading;

    function onUploadNewCover(asset: File, uploadProgressCallback: UploadProgressCallback, closeDialog: () => void) {
        uploadProductCoverMutation(
            { asset, uploadProgressCallback },
            {
                onSuccess: () => {
                    closeDialog();
                }
            }
        );
    }

    function onUploadNewAsset(asset: File, uploadProgressCallback: UploadProgressCallback, closeDialog: () => void) {
        uploadProductAssetMutation(
            { asset, uploadProgressCallback },
            {
                onSuccess: () => {
                    closeDialog();
                }
            }
        );
    }

    function onDeleteProduct() {
        deleteLocalContentProductMutation();
        navigate('..');
    }

    return (
        <>
            <LCProductDetailReadView
                loading={loading}
                product={product ?? {}}
                onUploadNewAsset={onUploadNewAsset}
                onUploadNewCover={onUploadNewCover}
                onDeleteCover={deleteProductCoverMutation}
                authentication={authentication}
                countries={countries ?? []}
                onDeleteProduct={onDeleteProduct}
                onWithdrawProduct={withdrawProductMutation}
                onSetLiveOnLibx={setLiveProductMutation}
                onDeactivateProduct={deactivateProductMutation}
                onReactivateProduct={reactivateLocalContentProductMutation}
                publishProduct={publishProductMutation}
                republishProduct={republishProductMutation}
                onSaveLibxSettings={saveLibxSettingsMutation}
            />
        </>
    );
};
